import { IsoDate, IsoDateTime, IsoDateTimeTz, IsoDuration, IsoTime, IsoTimeTz } from '../../types/iso-date';
import { deconstructDate } from './deconstruct-date.function';
import { setTimeTz } from '../set/set-time-tz.function';

export function assertDurationsForComparision<T extends IsoDuration>( ...a: T[] ): { ms: number, original: T }[] {
  let type: string | null = null;
  const returnValue: { ms: number, original: T }[] = []
  for (let t of a) {
    const deconstructed = deconstructDate(t);
    if(type && type !== deconstructed._type)
      throw new Error('assertDatesForComparision: all dates must be of the same type');
    type = deconstructed._type;
    switch (deconstructed._type){
      case 'duration':
        returnValue.push({
          ms: deconstructed.years * 31536000000
            + deconstructed.months * 2592000000
            + deconstructed.days * 86400000
            + deconstructed.hours * 3600000
            + deconstructed.minutes * 60000
            + deconstructed.seconds * 1000
            + deconstructed.milliseconds,
          original: t
        });
        break;
      default:
        throw new Error('assertDurationForComparision: invalid duration type');
    }
  }
  return returnValue;
}
